import React from 'react'

const DashboardLayout = () => {
  return (
    <div>
      <h1>DashboardLayout</h1>
    </div>
  )
}

export default DashboardLayout
